import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const state = {
  user: {
    email: '',
    password: '',
    data: {},
  },
  roles: [],
  error: {
    message: '',
    type: '',
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
